'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));
var web = require('@react-spring/web');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Dismiss = require('./components/Dismiss.js');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Container = styled.div.withConfig({
  componentId: "sc-3nrxy9-0"
})(function (_ref) {
  var s = _ref.s,
    onClick = _ref.onClick,
    error = _ref.error;
  return _objectSpread(_objectSpread({
    cursor: onClick ? 'pointer' : '',
    backgroundColor: '#fff',
    padding: '1.25rem'
  }, error && {
    borderColor: '#f00',
    backgroundColor: '#f00',
    color: '#fff'
  }), s);
});
var DismissContainer = styled.div.withConfig({
  componentId: "sc-3nrxy9-1"
})(["float:right;margin:1rem;"]);
var BlockAlert = function BlockAlert(_ref2) {
  var children = _ref2.children,
    show = _ref2.show,
    error = _ref2.error,
    onClick = _ref2.onClick,
    dismissible = _ref2.dismissible,
    dismiss = _ref2.dismiss,
    dismissOnClick = _ref2.dismissOnClick,
    timeout = _ref2.timeout;
  var _useTheme = nthHookTheme.useTheme(),
    alertContainerStyle = _useTheme.alertNoneNone,
    buttonsDismissStyle = _useTheme.buttonsDismissNone;
  var transitions = web.useTransition(show, {
    from: {
      opacity: 1
    },
    leave: {
      opacity: 0
    },
    config: {
      duration: timeout
    }
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, transitions(function (styles, item) {
    return item && /*#__PURE__*/React__default.createElement(web.animated.div, {
      style: styles
    }, dismissible && /*#__PURE__*/React__default.createElement(DismissContainer, null, dismiss || /*#__PURE__*/React__default.createElement(Dismiss.default, {
      s: _objectSpread(_objectSpread({}, error && {
        fill: '#fff'
      }), buttonsDismissStyle),
      onClick: dismissOnClick
    })), /*#__PURE__*/React__default.createElement(Container, {
      role: "alert",
      s: alertContainerStyle,
      onClick: onClick,
      error: error
    }, children));
  }));
};
BlockAlert.defaultProps = {
  show: false,
  error: false,
  dismissible: false,
  dismiss: undefined,
  onClick: undefined,
  dismissOnClick: undefined,
  timeout: 300
};
BlockAlert.propTypes = {
  children: PropTypes.node.isRequired,
  show: PropTypes.bool,
  error: PropTypes.bool,
  onClick: PropTypes.func,
  dismissible: PropTypes.bool,
  dismiss: PropTypes.node,
  dismissOnClick: PropTypes.func,
  timeout: PropTypes.number
};
var index = nthHookTheme.withThemeProvider(BlockAlert, {
  themeTokens: ['alertNoneNone', 'buttonsDismissNone']
});

exports.default = index;
